import { PROMO_DESCRIPTION_LINES } from './constants';
export function getDescriptionLinesNumber(props) {
    const { isMobileView, isTabletView } = props;
    if (isMobileView) {
        return PROMO_DESCRIPTION_LINES.sm;
    }
    if (isTabletView) {
        return PROMO_DESCRIPTION_LINES.md;
    }
    return PROMO_DESCRIPTION_LINES.lg;
}
